var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',[_c('div',{staticClass:"font-weight-bold text-primary"},[_vm._v(" Tarih ")]),(_vm.dataItem.ddate)?[_c('div',[_vm._v(" "+_vm._s(_vm.moment(_vm.dataItem.ddate).format('DD.MM.YYYY'))+" ")])]:[_vm._v(" Belirtilmedi ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }